import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { SlingoStyle } from "../style/SlingoStyle";
export class AbstractReelsProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.backgroundPurchaseProperties.equals(other.backgroundPurchaseProperties) &&
            this.size.equals(other.size);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.REEL_BACKGROUND, SlingoStyle.MODULE);
        this.backgroundPurchaseProperties = new SpriteProperties(SlingoStyle.REEL_PURCHASE_BACKGROUND, SlingoStyle.MODULE);
    }
}
//# sourceMappingURL=AbstractReelsProperties.js.map